<template>
  <section id="search-section">
    <div>
      <NavigationBar />
      <div
        class="uk-section uk-padding-remove-top uk-margin-top"
        v-if="!loading"
      >
        <div class="uk-container uk-margin-top">
          <h3>
            Search Product "<b>{{ this.$route.query.keyword }}</b
            >"
          </h3>
          <div v-if="products.length > 0" class="uk-grid">
            <div
              class="
                uk-width-1-5@l uk-width-1-4@m uk-width-1-3@s uk-margin-bottom
              "
              v-for="(prod, i) in products"
              :key="i"
            >
              <div class="uk-card uk-card-default">
                <div class="uk-card-media-top">
                  <router-link :to="`/product/${prod.seo_url}`">
                    <img
                      :src="prod.thumbnail"
                      :alt="prod.name"
                      style="object-fit: cover; height: 200px !important"
                      width="100%"
                    />
                  </router-link>
                </div>
                <div class="uk-card-body uk-padding-small">
                  <router-link :to="`/product/${prod.seo_url}`">
                    <h3
                      class="uk-card-title"
                      style="
                        overflow: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                        font-weight: bold;
                      "
                    >
                      {{ prod.name }}
                    </h3>
                  </router-link>
                  <div style="font-size: 14px">
                    {{ priceRupiah(prod.price) }}
                  </div>
                  <div class="uk-margin-top">
                    <router-link
                      :to="`/product/${prod.seo_url}`"
                      class="
                        uk-button
                        uk-button-primary
                        uk-button-small
                        uk-width-1-1
                        uk-padding-small
                        uk-padding-remove-top
                        uk-padding-remove-bottom
                      "
                    >
                      Detail
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="uk-flex">
            <div>Product not available!</div>
          </div>
        </div>
      </div>
      <div v-else class="uk-section" style="height: 70vh">
        <div class="uk-container" style="height: 100%">
          <div
            class="uk-flex uk-flex-center uk-flex-middle"
            style="height: 100%"
          >
            <div uk-spinner></div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  </section>
</template>

<script>
import NavigationBar from "@/components/NavigationBar.vue";
import Footer from "@/components/Footer.vue";
import $axios from "@/api.js";
import UIkit from "uikit";
import axios from "axios";
export default {
  components: {
    NavigationBar,
    Footer,
  },
  computed: {
    isMobile() {
      return window.innerWidth < 960;
    },
  },
  data() {
    return {
      products: [],
      loading: true,
    };
  },
  mounted() {
    this.getProduct();
    this.$root.$on("SearchPage", () => {
      this.getProduct();
    });
  },
  methods: {
    getProduct() {
      this.loading = true;
      this.products = [];
      const keyword = this.$route.query.keyword;
      const params = {
        q: keyword.trim(),
      };
      const paramsString = new URLSearchParams(params).toString();
      axios
        .get(
          `${process.env.VUE_APP_API_ROOMI_URL}product/search?${paramsString}`
        )
        .then((res) => {
          this.loading = false
          if (res.status == 200) {
            const data = res.data
            this.products = data.data
          } else {
            UIkit.notification({
              message: "Something went wrong!",
              status: "danger",
            });
          }
        })
        .catch((err) => {
          console.log(err.message);
          UIkit.notification({
            message: "Something went wrong!",
            status: "danger",
          });
          this.loading = false;
        });
    },
    priceRupiah: function (number) {
      let reverse = number.toString().split("").reverse().join("");
      let ribuan = reverse.match(/\d{1,3}/g);
      ribuan = ribuan.join(".").split("").reverse().join("");
      return "Rp " + ribuan;
    },
  },
};
</script>

<style lang="less" scoped>
@import "../custom/custom.less";
.uk-card-title {
  font-size: 18px;
}
a {
  &:hover {
    .uk-card-title {
      color: @primary-color;
    }
  }
}
</style>